import React from 'react';
import { useApp } from '@context/AppContext';
import { PageTitleBanner } from '@goodfynd/layout';
import { LoadingTruck } from '@goodfynd/ui';
import { useRequireAuth } from '@hooks/useRequireAuth';

import Footer from '../Footer';
import Header from '../Header';
import { LoadingFullPage } from '../LoadingFullPage';

import type { LayoutWithHeaderProps } from './types';

import classes from './LayoutWithHeader.module.css';

export function LayoutWithHeader({
  children,
  authRequired = false,
  allowedRoles = [],
  bannerContainerCss,
  bannerTitle,
  bannerSubTitle,
}: Pick<
  LayoutWithHeaderProps,
  | 'children'
  | 'authRequired'
  | 'allowedRoles'
  | 'bannerContainerCss'
  | 'bannerTitle'
  | 'bannerSubTitle'
>): JSX.Element {
  const isLoggedIn = useRequireAuth({ allowedRoles, authRequired });
  const { userIsLoading } = useApp();

  if (authRequired && !isLoggedIn) {
    return <></>;
  }

  return (
    <div className={classes['page-container']} style={{ paddingTop: 64 }}>
      <Header />

      <>
        {typeof bannerTitle === 'string' ? (
          <PageTitleBanner
            containerCss={bannerContainerCss}
            subtitle={bannerSubTitle}
            title={bannerTitle}
          />
        ) : (
          bannerTitle
        )}

        {userIsLoading ? (
          <LoadingFullPage>
            <LoadingTruck />
          </LoadingFullPage>
        ) : (
          children
        )}
      </>

      <Footer />
    </div>
  );
}
